module.exports = __webpack_public_path__ + "media/images/home/cover-desktop@2x-9b4247f81b3a7046198a2796783107b5.jpg";